import React, { useState } from 'react';
import { createForm, addFormAuth } from '../../api/aprvForms';
import OrgSelect from '../../components/OrgSelect/OrgSelect';

export default function AprvFormsForm({ onCancel, token, comCode, onRefresh, folderOptions }) {
  const [formData, setFormData] = useState({
    form_code: '',
    form_name: '',
    parent_code: '',
    form_type: 'folder',
    sub_form_code: '',
    sort_order: 0,
    use_yn: 'Y',
    auth_role: 'all',
  });

  // ✅ 권한 목록 (OrgSelect로 선택)
  const [auths, setAuths] = useState([]);
  const [saving, setSaving] = useState(false);
  const [showOrgPopup, setShowOrgPopup] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.form_code || !formData.form_name) {
      return alert('코드와 이름은 필수입니다');
    }
    try {
      setSaving(true);
      // 1) 양식 생성
      await createForm(formData, token, comCode);

      // 2) 권한 추가 (auths 배열에 있는 값 반영)
      for (const a of auths) {
        await addFormAuth(formData.form_code, a, token, comCode);
      }

      alert('양식이 생성되었습니다');
      onCancel();
      onRefresh();
    } catch (err) {
      console.error('양식 생성 실패:', err);
      alert('양식 생성 중 오류가 발생했습니다');
    } finally {
      setSaving(false);
    }
  };

  // ✅ OrgSelect에서 확인 버튼 눌렀을 때
  const handleConfirmOrgSelection = (selectedTargets) => {
    setAuths(selectedTargets); // 로컬 상태만 업데이트
    setShowOrgPopup(false);
  };

  return (
    <div className="card">
      <div className="card-header">➕ 결재양식 생성</div>
      <div className="card-body">
        <form onSubmit={handleSubmit}>
          {/* 기본 정보 */}
          <div className="mb-2">
            <label className="form-label">코드</label>
            <input
              type="text"
              name="form_code"
              className="form-control"
              value={formData.form_code}
              onChange={handleChange}
              required
            />
          </div>
          <div className="mb-2">
            <label className="form-label">이름</label>
            <input
              type="text"
              name="form_name"
              className="form-control"
              value={formData.form_name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="mb-2">
            <label className="form-label">상위 코드(parent_code)</label>
            <select
              name="parent_code"
              className="form-select"
              value={formData.parent_code}
              onChange={handleChange}
            >
              {folderOptions.map((opt) => (
                <option key={opt.code} value={opt.code}>
                  {opt.name} ({opt.code})
                </option>
              ))}
            </select>
          </div>
          <div className="mb-2">
            <label className="form-label">유형(form_type)</label>
            <select
              name="form_type"
              className="form-select"
              value={formData.form_type}
              onChange={handleChange}
            >
              <option value="folder">폴더</option>
              <option value="form">양식</option>
            </select>
          </div>
          <div className="mb-2">
            <label className="form-label">하위 양식 코드(sub_form_code)</label>
            <input
              type="text"
              name="sub_form_code"
              className="form-control"
              value={formData.sub_form_code}
              onChange={handleChange}
            />
          </div>
          <div className="mb-2">
            <label className="form-label">정렬 순서(sort_order)</label>
            <input
              type="number"
              name="sort_order"
              className="form-control"
              value={formData.sort_order}
              onChange={handleChange}
            />
          </div>
          <div className="mb-2">
            <label className="form-label">사용 여부(use_yn)</label>
            <select
              name="use_yn"
              className="form-select"
              value={formData.use_yn}
              onChange={handleChange}
            >
              <option value="Y">사용</option>
              <option value="N">미사용</option>
            </select>
          </div>
          <div className="mb-3">
            <label className="form-label">권한 역할(auth_role)</label>
            <select
              name="auth_role"
              className="form-select"
              value={formData.auth_role}
              onChange={handleChange}
            >
              <option value="all">전체</option>
              <option value="admin">관리자</option>
              <option value="manager">매니저</option>
            </select>
          </div>

          {/* ✅ 권한 관리 섹션 */}
          <div className="mb-3">
            <div className="d-flex justify-content-between align-items-center">
              <label className="form-label mb-0">권한 관리</label>
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => setShowOrgPopup(true)}
              >
                권한 추가
              </button>
            </div>

            {Array.isArray(auths) && auths.length > 0 ? (
              <ul className="list-group mb-2">
                {auths.map((a) => (
                  <li
                    key={`${a.target_type}-${a.target_id}`}
                    className="list-group-item d-flex justify-content-between align-items-center"
                  >
                    <span>
                      <strong>{a.target_type === 'user' ? '사용자' : '부서'}:</strong>{' '}
                      {a.target_name || a.target_id}
                    </span>
                    <button
                      type="button"
                      className="btn btn-sm btn-outline-danger"
                      onClick={() =>
                        setAuths(
                          auths.filter(
                            (x) =>
                              !(
                                x.target_type === a.target_type &&
                                x.target_id === a.target_id
                              )
                          )
                        )
                      }
                    >
                      삭제
                    </button>
                  </li>
                ))}
              </ul>
            ) : (
              <div className="text-muted mb-2">등록된 권한이 없습니다</div>
            )}
          </div>

          {/* 액션 */}
          <div className="d-flex justify-content-end">
            <button type="submit" className="btn btn-primary me-2" disabled={saving}>
              {saving ? '생성 중...' : '생성'}
            </button>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onCancel}
              disabled={saving}
            >
              취소
            </button>
          </div>
        </form>
      </div>

      {/* ✅ OrgSelect 레이어 팝업 */}
      {showOrgPopup && (
        <OrgSelect
          comCode={comCode}
          onConfirm={handleConfirmOrgSelection}
          onCancel={() => setShowOrgPopup(false)}
          selectionMode="multiple"
          targetType="all"
          initialSelected={auths}
        />
      )}
    </div>
  );
}